module.exports = __webpack_public_path__ + "static/media/insights.4944d266.svg";